import 'url-search-params-polyfill';
import axios from 'axios';
import config from 'config';

import WindowProxy from 'commons-core-services/services/WindowProxy/WindowProxy.js';

const TokenService = {
    fetchFromBackend() {
        const windowProxy = WindowProxy.get();
        const body = new URLSearchParams();
        body.append('grant_type', 'client_credentials');

        return axios({
            method: 'post',
            url: `${config.endpoint.authentication}/token`,
            auth: {
                username: 'widgets',
                password: config.secrets.authentication,
            },
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            data: body,
        })
            .then(({ data }) => {
                const { access_token: token, expires_in: expiresIn } = data;
                // count token expiry based on expiry from response * 1000 (for miliseconds) and add to the current date
                // Convert expiry date into time as integer to store into localStorage
                const currentTime = new Date().getTime();
                const tokenExpiresAt = new Date(currentTime + expiresIn * 1000).getTime();
                const accessToken = { value: token, expiresAt: tokenExpiresAt };
                if (windowProxy && windowProxy.localStorage) {
                    windowProxy.localStorage.setItem('accessToken', JSON.stringify(accessToken));
                    return Promise.resolve(accessToken.value);
                }
                return Promise.reject();
            })
            .catch((e) => {
                console.error('Unable to fetch the token', e);
                return Promise.reject();
            });
    },

    fetch() {
        const windowProxy = WindowProxy.get();
        if (windowProxy && windowProxy.localStorage) {
            const accessToken = JSON.parse(windowProxy.localStorage.getItem('accessToken'));
            if (accessToken) {
                // Compare current time with the token expiration time
                const currentTime = new Date().getTime();
                const isValidToken = currentTime < accessToken?.expiresAt;

                if (accessToken?.value && isValidToken) {
                    return Promise.resolve(accessToken.value);
                }
            }
        }
        return this.fetchFromBackend();
    },
};

export default TokenService;
